// extracted by mini-css-extract-plugin
export var deleteIcon = "_ql-5";
export var deleteOption = "_ql-3";
export var divider = "_ql-2";
export var downloadIcon = "_ql-4";
export var drawer = "_ql-0";
export var drawerFooter = "_ql-6";
export var drawerOpen = "_ql-1";
export var highlighted = "_ql-7";
export var lighterHighlight = "_ql-8";